module.exports = __webpack_public_path__ + "img/Eco-Explorations.6de5383e.png";